import React, { useEffect, useState } from 'react';

import { Dropdown } from '@pkg/components/Sections/Admin';
import { useToastStore } from '@pkg/components/Toast/useToastStore';
import { useQueryInvalidation, useUpdateCollectionStatus } from '@pkg/hooks';

import { type CompetitionCollection, CompetitionCollectionStatus } from '@app/client';
import { COLLECTION_STATUS_QUERIES, WISHLIST_SUMMARY_CACHE } from '@app/client/resources/fantasy';

import { CollectionSlug, CollectionStatus, ListTable } from './styles';

interface CollectionListItemProps {
    item: CompetitionCollection;
}

export const CollectionListItem = ({ item }: CollectionListItemProps) => {
    const [status, setStatus] = useState<CompetitionCollectionStatus>();
    const { mutateAsync: updateCollectionStatus, isPending } = useUpdateCollectionStatus();
    const invalidateCollection = useQueryInvalidation([...COLLECTION_STATUS_QUERIES, ...WISHLIST_SUMMARY_CACHE]);
    const { addToast } = useToastStore();

    useEffect(() => setStatus(item.status), [item.status]);
    function handleStatusChange(e) {
        if (isPending) return;
        const newStatus = e.target.value;
        setStatus(newStatus);
        updateCollectionStatus({ value: { status: newStatus }, collectionSlug: item.slug, chain: item.network }).then(
            (data) => {
                if (data.ok) {
                    invalidateCollection();

                    addToast({
                        emoji: '👀',
                        message: `Successfully updated status for collection: ${data.value.slug}`,
                    });
                }
            },
        );
    }
    return (
        <ListTable>
            <CollectionSlug $status={status} href={`https://y.at/collection/${item.network}/${item.slug}`}>
                {item.slug}
            </CollectionSlug>
            <CollectionStatus>
                <Dropdown
                    onChange={(e) => handleStatusChange(e)}
                    compact
                    defaultValue={CompetitionCollectionStatus[item.status]}
                >
                    <option value="" disabled>
                        Change status
                    </option>
                    {Object.keys(CompetitionCollectionStatus).map((statusKey) => {
                        return (
                            <option key={statusKey} value={CompetitionCollectionStatus[statusKey]}>
                                {CompetitionCollectionStatus[statusKey]}
                            </option>
                        );
                    })}
                </Dropdown>
            </CollectionStatus>
        </ListTable>
    );
};
